import { AppRouter } from './app/router';

export default function App() {
  return <AppRouter />;
}

